import * as React from "react";
import type { SVGProps } from "react";
const SvgStatusInactive = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="#BDBDBD"
            fillRule="evenodd"
            d="M13.735 3.169a9 9 0 1 0-3.47 17.662 9 9 0 0 0 3.47-17.662M9.828 1.217a11 11 0 1 1 4.344 21.566A11 11 0 0 1 9.828 1.217"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgStatusInactive;
